import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import '../styles/FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      id: 'what-is-performance-marketing-consultant',
      question: 'What does a performance marketing consultant do?',
      answer: 'A performance marketing consultant helps businesses scale revenue through data-driven paid media strategies. I audit existing campaigns, identify waste, design optimization roadmaps, and implement systems for profitable customer acquisition across Google Ads, Meta Ads, LinkedIn, and programmatic channels. The focus is always on measurable ROI, not vanity metrics.'
    },
    {
      id: 'growth-vs-digital-marketing',
      question: 'How is a growth marketing consultant different from a digital marketing consultant?',
      answer: 'A growth marketing consultant focuses on full-funnel optimization — acquisition, activation, retention, and revenue. A digital marketing consultant typically provides broader strategic guidance across channels. My approach combines both: I provide strategic consulting while also executing hands-on performance marketing campaigns with a growth mindset.'
    },
    {
      id: 'services-included',
      question: 'What services does a digital marketing consultant provide?',
      answer: 'As a digital marketing consultant, I provide paid media strategy and execution, analytics implementation (GA4, GTM, server-side tracking), attribution modeling, conversion rate optimization, AI workflow integration, and marketing technology audits. I specialize in technical marketing infrastructure that drives measurable revenue growth.'
    },
    {
      id: 'types-of-businesses',
      question: 'What kinds of businesses do you work with?',
      answer: 'I work with DTC/eCommerce brands, B2B companies, SaaS businesses, and growth-stage startups. Ideal clients are ready to invest in data-driven marketing infrastructure, typically spending $10K+/month on paid media or preparing to scale aggressively. I help businesses that are serious about profitable growth, not experimentation.'
    },
    {
      id: 'b2b-and-b2c',
      question: 'Do you work with both B2B and B2C brands?',
      answer: 'Yes. I have 16+ years of experience leading performance marketing for both B2B and B2C brands globally. B2B clients benefit from my expertise in LinkedIn Ads, Google Ads for lead generation, and pipeline attribution. B2C/DTC clients benefit from my eCommerce optimization, Meta Ads strategies, and customer acquisition frameworks.'
    },
    {
      id: 'ga4-gtm-attribution',
      question: 'Can you help with GA4, GTM, attribution, and server-side tracking?',
      answer: 'Absolutely. Advanced analytics and attribution are core to my consulting services. I implement Google Analytics 4, Google Tag Manager (including server-side containers), multi-touch attribution models, and Marketing Efficiency Ratio (MER) frameworks. I help businesses move beyond broken last-click attribution to true performance visibility.'
    },
    {
      id: 'engagement-model',
      question: 'What does an engagement look like?',
      answer: 'Engagements typically start with a strategy audit (2-4 weeks) where I review your current setup, identify gaps, and deliver a prioritized roadmap. From there, we move into execution: campaign optimization, analytics implementation, or ongoing consulting retainers. I work both project-based and on retainer depending on your needs.'
    },
    {
      id: 'remote-consulting',
      question: 'Are you available for remote consulting?',
      answer: "Yes. I'm based in Kolkata, India, but work with clients globally via remote consulting. I've led campaigns for businesses across North America, Europe, and Asia. Time zone differences are never an issue — I structure communication for seamless collaboration regardless of location."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq">
      <div className="faq-container">
        <div className="faq-header reveal">
          <div className="section-label">Common Questions</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="title-underline"></div>
          <p className="faq-subtitle">
            Everything you need to know about working with a performance marketing consultant.
          </p>
        </div>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={faq.id} className={`faq-item ${openIndex === index ? 'active' : ''}`}>
              <button 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <ChevronDown 
                  size={20} 
                  className={`faq-icon ${openIndex === index ? 'rotate' : ''}`} 
                />
              </button>
              <div className={`faq-answer ${openIndex === index ? 'show' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
